// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2Zgz8","options":"AnswerScale_options__30UGd","selected":"AnswerScale_selected__3i5uy"};